export const EU_COUNTRIES = [
  'AT', // Austria
  'BE', // Belgium
  'BG', // Bulgaria
  'HR', // Croatia
  'CY', // Cyprus
  'CZ', // Czechia
  'DK', // Denmark
  'EE', // Estonia
  'FI', // Finland
  'FR', // France
  'DE', // Germany
  'GR', // Greece
  'HU', // Hungary
  'IE', // Ireland
  'IT', // Italy
  'LV', // Latvia
  'LT', // Lithuania
  'LU', // Luxemburg
  'MT', // Malta
  'NL', // Netherlands
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'SK', // Slovakia
  'SI', // Slovenia
  'ES', // Spain
  'SE', // Sweden
];

export const COUNTRY_LIST = [
  'AF',
  'AX',
  'AL',
  'DZ',
  'AS',
  'AD',
  'AO',
  'AI',
  'AQ',
  'AG',
  'AR',
  'AM',
  'AW',
  'AU',
  'AT',
  'AZ',
  'BS',
  'BH',
  'BD',
  'BB',
  'BY',
  'BE',
  'BZ',
  'BJ',
  'BM',
  'BT',
  'BO',
  'BA',
  'BW',
  'BV',
  'BR',
  'BQ',
  'VG',
  'IO',
  'BN',
  'BG',
  'BF',
  'BI',
  'KH',
  'CM',
  'CA',
  'CV',
  'KY',
  'CF',
  'TD',
  'CL',
  'CN',
  'HK',
  'MO',
  'CX',
  'CC',
  'CO',
  'KM',
  'CG',
  'CD',
  'CK',
  'CR',
  'CI',
  'HR',
  'CU',
  'CW',
  'CY',
  'CZ',
  'DK',
  'DJ',
  'DM',
  'DO',
  'EC',
  'EG',
  'SV',
  'GQ',
  'ER',
  'EE',
  'ET',
  'FK',
  'FO',
  'FJ',
  'FI',
  'FR',
  'GF',
  'PF',
  'TF',
  'GA',
  'GM',
  'GE',
  'DE',
  'GH',
  'GI',
  'GR',
  'GL',
  'GD',
  'GP',
  'GU',
  'GT',
  'GG',
  'GN',
  'GW',
  'GY',
  'HT',
  'HM',
  'VA',
  'HN',
  'HU',
  'IS',
  'IN',
  'ID',
  'IR',
  'IQ',
  'IE',
  'IM',
  'IL',
  'IT',
  'JM',
  'JP',
  'JE',
  'JO',
  'KZ',
  'KE',
  'KI',
  'KP',
  'KR',
  'KW',
  'KG',
  'LA',
  'LV',
  'LB',
  'LS',
  'LR',
  'LY',
  'LI',
  'LT',
  'LU',
  'MK',
  'MG',
  'MW',
  'MY',
  'MV',
  'ML',
  'MT',
  'MH',
  'MQ',
  'MR',
  'MU',
  'YT',
  'MX',
  'FM',
  'MD',
  'MC',
  'MN',
  'ME',
  'MS',
  'MA',
  'MZ',
  'MM',
  'NA',
  'NR',
  'NP',
  'NL',
  'AN',
  'NC',
  'NZ',
  'NI',
  'NE',
  'NG',
  'NU',
  'NF',
  'MP',
  'NO',
  'OM',
  'PK',
  'PW',
  'PS',
  'PA',
  'PG',
  'PY',
  'PE',
  'PH',
  'PN',
  'PL',
  'PT',
  'PR',
  'QA',
  'RE',
  'RO',
  'RU',
  'RW',
  'BL',
  'SH',
  'KN',
  'LC',
  'MF',
  'PM',
  'VC',
  'WS',
  'SM',
  'ST',
  'SA',
  'SN',
  'RS',
  'SC',
  'SL',
  'SG',
  'SX',
  'SK',
  'SI',
  'SB',
  'SO',
  'ZA',
  'GS',
  'SS',
  'ES',
  'LK',
  'SD',
  'SR',
  'SJ',
  'SZ',
  'SE',
  'CH',
  'SY',
  'TW',
  'TJ',
  'TZ',
  'TH',
  'TL',
  'TG',
  'TK',
  'TO',
  'TT',
  'TN',
  'TR',
  'TM',
  'TC',
  'TV',
  'UG',
  'UA',
  'AE',
  'GB',
  'US',
  'UM',
  'UY',
  'UZ',
  'VU',
  'VE',
  'VN',
  'VI',
  'WF',
  'EH',
  'YE',
  'ZM',
  'ZW',
  'XK',
];

export enum AVAILABLE_COUNTRIES {
  'US' = 'United States',
  'CA' = 'Canada',
  'MX' = 'Mexico',
  'BR' = 'Brazil',
  'ES' = 'Spain',
  'UK' = 'United Kingdom',
  'FR' = 'France',
  'BE' = 'Belgium',
  'NL' = 'Netherlands',
  'DE' = 'Germany',
  'IT' = 'Italy',
  'SE' = 'Sweden',
  'ZA' = 'South Africa',
  'PL' = 'Poland',
  'EG' = 'Egypt',
  'TR' = 'Türkiye',
  'SA' = 'Saudi Arabia',
  'AE' = 'United Arab Emirates',
  'IN' = 'India',
  'AU' = 'Australia',
  'JP' = 'Japan',
  'CN' = 'China',
  'SG' = 'Singapore',
  'MY' = 'Malaysia',
  'TH' = 'Thailand',
  'KR' = 'South Korea',
  'TW' = 'Taiwan',
  'HK' = 'Hong Kong',
  'PH' = 'Philippines',
  'VN' = 'Vietnam',
  'ID' = 'Indonesia',
  'RU' = 'Russia',
  'UA' = 'Ukraine',
}

export const AVAILABLE_US_STATES = [
  { name: 'Alabama', abbreviation: 'AL' },
  { name: 'Alaska', abbreviation: 'AK' },
  { name: 'Arizona', abbreviation: 'AZ' },
  { name: 'Arkansas', abbreviation: 'AR' },
  { name: 'California', abbreviation: 'CA' },
  { name: 'Colorado', abbreviation: 'CO' },
  { name: 'Connecticut', abbreviation: 'CT' },
  { name: 'Delaware', abbreviation: 'DE' },
  { name: 'Florida', abbreviation: 'FL' },
  { name: 'Georgia', abbreviation: 'GA' },
  { name: 'Hawaii', abbreviation: 'HI' },
  { name: 'Idaho', abbreviation: 'ID' },
  { name: 'Illinois', abbreviation: 'IL' },
  { name: 'Indiana', abbreviation: 'IN' },
  { name: 'Iowa', abbreviation: 'IA' },
  { name: 'Kansas', abbreviation: 'KS' },
  { name: 'Kentucky', abbreviation: 'KY' },
  { name: 'Louisiana', abbreviation: 'LA' },
  { name: 'Maine', abbreviation: 'ME' },
  { name: 'Maryland', abbreviation: 'MD' },
  { name: 'Massachusetts', abbreviation: 'MA' },
  { name: 'Michigan', abbreviation: 'MI' },
  { name: 'Minnesota', abbreviation: 'MN' },
  { name: 'Mississippi', abbreviation: 'MS' },
  { name: 'Missouri', abbreviation: 'MO' },
  { name: 'Montana', abbreviation: 'MT' },
  { name: 'Nebraska', abbreviation: 'NE' },
  { name: 'Nevada', abbreviation: 'NV' },
  { name: 'New Hampshire', abbreviation: 'NH' },
  { name: 'New Jersey', abbreviation: 'NJ' },
  { name: 'New Mexico', abbreviation: 'NM' },
  { name: 'New York', abbreviation: 'NY' },
  { name: 'North Carolina', abbreviation: 'NC' },
  { name: 'North Dakota', abbreviation: 'ND' },
  { name: 'Ohio', abbreviation: 'OH' },
  { name: 'Oklahoma', abbreviation: 'OK' },
  { name: 'Oregon', abbreviation: 'OR' },
  { name: 'Pennsylvania', abbreviation: 'PA' },
  { name: 'Rhode Island', abbreviation: 'RI' },
  { name: 'South Carolina', abbreviation: 'SC' },
  { name: 'South Dakota', abbreviation: 'SD' },
  { name: 'Tennessee', abbreviation: 'TN' },
  { name: 'Texas', abbreviation: 'TX' },
  { name: 'Utah', abbreviation: 'UT' },
  { name: 'Vermont', abbreviation: 'VT' },
  { name: 'Virginia', abbreviation: 'VA' },
  { name: 'Washington', abbreviation: 'WA' },
  { name: 'West Virginia', abbreviation: 'WV' },
  { name: 'Wisconsin', abbreviation: 'WI' },
  { name: 'Wyoming', abbreviation: 'WY' },
];

export const AVAILABLE_MEXICO_STATES = [
  {
    name: 'Aguascalientes',
    abbreviation: 'AG',
  },
  {
    name: 'Baja California',
    abbreviation: 'BC',
  },
  {
    name: 'Baja California Sur',
    abbreviation: 'BS',
  },
  {
    name: 'Campeche',
    abbreviation: 'CM',
  },
  {
    name: 'Chiapas',
    abbreviation: 'CS',
  },
  {
    name: 'Chihuahua',
    abbreviation: 'CH',
  },
  {
    name: 'Coahuila',
    abbreviation: 'CO',
  },
  {
    name: 'Colima',
    abbreviation: 'CL',
  },
  {
    name: 'Durango',
    abbreviation: 'DG',
  },
  {
    name: 'Guanajuato',
    abbreviation: 'GT',
  },
  {
    name: 'Guerrero',
    abbreviation: 'GR',
  },
  {
    name: 'Hidalgo',
    abbreviation: 'HG',
  },
  {
    name: 'Jalisco',
    abbreviation: 'JA',
  },
  {
    name: 'México',
    abbreviation: 'ME',
  },
  {
    name: 'Mexico City',
    abbreviation: 'CMX',
  },
  {
    name: 'Michoacán',
    abbreviation: 'MI',
  },
  {
    name: 'Morelos',
    abbreviation: 'MO',
  },
  {
    name: 'Nayarit',
    abbreviation: 'NA',
  },
  {
    name: 'Nuevo León',
    abbreviation: 'NL',
  },
  {
    name: 'Oaxaca',
    abbreviation: 'OA',
  },
  {
    name: 'Puebla',
    abbreviation: 'PB',
  },
  {
    name: 'Querétaro',
    abbreviation: 'QE',
  },
  {
    name: 'Quintana Roo',
    abbreviation: 'QR',
  },
  {
    name: 'San Luis Potosí',
    abbreviation: 'SL',
  },
  {
    name: 'Sinaloa',
    abbreviation: 'SI',
  },
  {
    name: 'Sonora',
    abbreviation: 'SO',
  },
  {
    name: 'Tabasco',
    abbreviation: 'TB',
  },
  {
    name: 'Tamaulipas',
    abbreviation: 'TM',
  },
  {
    name: 'Tlaxcala',
    abbreviation: 'TL',
  },
  {
    name: 'Veracruz',
    abbreviation: 'VE',
  },
  {
    name: 'Yucatán',
    abbreviation: 'YU',
  },
  {
    name: 'Zacatecas',
    abbreviation: 'ZA',
  },
  {
    name: 'Zacatecas',
    abbreviation: 'ZA',
  },
];
